import "./FeaturedWork.css";

export default function FeaturedWork() {
  return (
    <section className="featured-section section" id="featured">
      <div className="container">
        {/* centered label */}
        <div className="featured-label reveal">FEATURED WORK</div>

        {/* single-column card */}
        <div className="featured-card reveal">
          {/* ── text block ── */}
          <div className="featured-text">
            <h3>Creating Impactful Games That Players Remember</h3>
            <p>
              We design and develop engaging games with immersive gameplay, stunning
              visuals, and optimised performance. Our focus is on creating experiences that
              captivate players and deliver real value for businesses.
            </p>
            {/* purple dot-grid decoration */}
            <div className="featured-dots-grid" aria-hidden="true" />
          </div>

          {/* ── image placeholder (full width) ── */}
          <div className="featured-image">
            <img src="/video3-1.jpg" alt="Featured Work" className="featured-image-img" loading="lazy" />
          </div>
        </div>
      </div>
    </section>
  );
}
